import { defineAsyncComponent } from 'vue'
export default {
  account: defineAsyncComponent(() => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/layouts/account.vue")),
  default: defineAsyncComponent(() => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/layouts/default.vue")),
  none: defineAsyncComponent(() => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/layouts/none.vue")),
  website: defineAsyncComponent(() => import("/codebuild/output/src2221583704/src/online-profile-bookforme-nuxt/layouts/website.vue"))
}